export default __webpack_public_path__ + "static/media/ic_gitbook.d2ceaa40.svg";